import { FORMS_TYPES } from "redux/types/FormsTypes";

export const changeForms = (payload) => ({
  type: FORMS_TYPES.FOMR_UPLOAD,
  payload
});
